import { Checkbox, Drawer, FormControl, FormControlLabel, Grid2, InputLabel, MenuItem, Select } from "@mui/material";
import { useEffect, useState } from "react";
import { ValidatorForm } from "react-material-ui-form-validator";
import { useParams } from "react-router-dom";
import { RoleEnum, RoleStringEnum } from "../../_common/enum";
import { IDropdownData } from "../../_common/interface/dropdown/iDropdownData.interface";
import { StandardButton } from "../../_components/button/primary.button";
import { DrawerHeader } from "../../_components/drawer/header.drawer";
import { StandardTextValidator } from "../../_components/textValidator/standardTextValidator";
import { toastr } from "../../_components/toastr/toastr";
import { RESET_PASSWORD_ERROR_MESSAGES, RESET_PASSWORD_HELPER_TEXT, RESET_PASSWORD_VALIDATORS } from "../../_const/security.const";
import { handleErrorResponse } from "../../_helpers/handleResponse.helper";
import { ticketStatusService } from "../../_services/ticketStatus.service ";

export const TicketStatusManageDrawer = (params: { isOpen?: boolean, onSave(): void, onClose(): void }) => {

    const resetData = () => ({});

    const { id } = useParams<{ id: string }>();

    const [data, setData] = useState<any>(resetData);
    const [isLoading, setIsLoading] = useState(false);
    const [saving, setIsSaving] = useState(false);
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        if (id != null)
            fetchData();
        else
            setData(resetData);
    }, [id]);

    useEffect(() => {
        if (isOpen == false)
            setIsOpen(true);
    }, []);

    function fetchData() {
        if (!id) return;

        setIsLoading(true);
        return ticketStatusService
            .get(id)
            .then(
                (json) => {
                    setData(json);
                }, handleErrorResponse
            )
            .finally(() => {
                setIsLoading(false);
            });
    }

    function submit(e: any) {
        e.preventDefault();
        setIsSaving(true);

        return ticketStatusService
            .submit(data)
            .then(
                () => {
                    toastr.success("Saved successfully");
                    resetData();
                    params.onSave();
                }, handleErrorResponse
            )
            .finally(() => setIsSaving(false));
    }

    function disable() {
        if (!id) return;
        setIsLoading(true);
        return ticketStatusService
            .disable(id)
            .then(
                () => {
                    toastr.success("Disabled successfully");
                    params.onSave();
                }, handleErrorResponse
            )
            .finally(() => setIsLoading(false));
    }

    function handleChange(event: any) {
        setData((_data: any) => ({ ..._data, [event.target.name]: event.target.value }));
    }

    return (
        <Drawer
            anchor={"right"}
            variant="persistent"
            open={isOpen}
            ModalProps={{
                keepMounted: true
            }}>

            <DrawerHeader name={(!!id) ? "Update Ticket Status Type" : "Create Ticket Status"} onClose={params.onClose} />

            <ValidatorForm
                onSubmit={submit}
                noValidate>

                <Grid2 container spacing={1} sx={{ "padding": "8px"}}>
                    <Grid2 size={{ xs: 12 }}>
                        <StandardTextValidator
                            key="name"
                            name="name"
                            label="Name"
                            required
                            fullWidth
                            validators={['required', 'minStringLength:1']}
                            errorMessages={['required field', "Field cannot be empty"]}
                            value={data.name}
                            onChange={handleChange}
                        />
                    </Grid2>

                    <Grid2 size={{ xs: 12 }}>
                        <Grid2 container spacing={1}>
                            <Grid2 size={{ xs: data.id == null ? 12 : data?.isActive === false ? 12 : 6 }}>
                                <StandardButton
                                    saving={saving}
                                    loading={isLoading}
                                    icon="save"
                                    type="submit">
                                    {(data?.isActive === false) ? "Save and Reactivate" : "Save"}
                                </StandardButton>
                            </Grid2>

                            {(!!id && data?.isActive === true) &&
                                <Grid2 size={{ xs: 6 }}>
                                    <StandardButton
                                        saving={saving}
                                        loading={isLoading}
                                        icon="block"
                                        variant="error"
                                        onClick={disable}>
                                        Disable
                                    </StandardButton>
                                </Grid2>
                            }
                        </Grid2>
                    </Grid2>
                </Grid2>

            </ValidatorForm>
        </Drawer>
    );
};